(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  /* ---------- Mobile nav ---------- */
  var mobileToggle = document.getElementById('MobileNavToggle');
  var mobileNav = document.getElementById('MobileNav');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('hidden');
      var expanded = mobileToggle.getAttribute('aria-expanded') === 'true';
      mobileToggle.setAttribute('aria-expanded', String(!expanded));
    });
  }

  /* ---------- Search bar ---------- */
  var searchToggle = document.getElementById('SearchToggle');
  var searchBar = document.getElementById('SearchBar');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      searchBar.classList.toggle('hidden');
      if (!searchBar.classList.contains('hidden')) {
        var input = searchBar.querySelector('input');
        if (input) input.focus();
      }
    });
  }

  /* ---------- Cart drawer ---------- */
  var cartToggle = document.getElementById('CartToggle');
  var cartDrawer = document.getElementById('CartDrawer');
  var cartOverlay = document.getElementById('CartOverlay');
  var cartClose = document.getElementById('CartClose');
  var cartBody = document.getElementById('CartDrawerBody');
  var cartSubtotal = document.getElementById('CartSubtotal');
  var cartCount = document.getElementById('CartCount');

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderCart(cart) {
    if (!cartBody) return;
    if (!cart.items.length) {
      cartBody.innerHTML = '<p class="cart-empty-msg">Your cart is empty.</p>';
    } else {
      cartBody.innerHTML = cart.items.map(function (item) {
        return (
          '<div class="cart-drawer-item">' +
            (item.image ? '<img src="' + item.image + '&width=160" alt="">' : '') +
            '<div>' +
              '<div class="cdi-title">' + item.product_title + '</div>' +
              (item.variant_title ? '<div class="cdi-variant">' + item.variant_title + '</div>' : '') +
              '<div class="cdi-price">' + item.quantity + ' × ' + money(item.price) + '</div>' +
            '</div>' +
          '</div>'
        );
      }).join('');
    }
    if (cartSubtotal) cartSubtotal.textContent = money(cart.total_price);
    if (cartCount) cartCount.textContent = cart.item_count;
  }

  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('hidden');
    if (cartOverlay) cartOverlay.classList.remove('hidden');
    refreshCart();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('hidden');
    if (cartOverlay) cartOverlay.classList.add('hidden');
  }

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* ---------- Product form AJAX add-to-cart ---------- */
  var productForm = document.getElementById('ProductForm');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(productForm);
      fetch('/cart/add.js', { method: 'POST', body: fd })
        .then(function (r) { return r.json(); })
        .then(function () { openCart(); })
        .catch(function () { window.location.href = '/cart'; });
    });
  }

  /* ---------- Cart page quantity steppers ---------- */
  document.querySelectorAll('[data-cart-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.querySelector('[data-cart-qty="' + btn.dataset.cartMinus + '"]');
      if (input) input.value = Math.max(0, (parseInt(input.value) || 0) - 1);
    });
  });
  document.querySelectorAll('[data-cart-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.querySelector('[data-cart-qty="' + btn.dataset.cartPlus + '"]');
      if (input) input.value = (parseInt(input.value) || 0) + 1;
    });
  });

  window.addEventListener('DOMContentLoaded', function () {
    if (cartCount) refreshCart();
  });
})();
